import clsx from "clsx";

/** Props Interface */
interface TabFloaterProps {
	hasError?: boolean;
}

export function TabFloater({ hasError = false }: TabFloaterProps) {
	/** Render */
	return (
		<div
			className={clsx(
				"bottom-0 left-0 absolute w-full h-0.5 pointer-events-none",
				hasError ? "bg-amber-500" : "bg-accent-500",
			)}
		/>
	);
}
